// extracted by mini-css-extract-plugin
module.exports = {"caterers_list":"_16mHX"};